import * as $runtime from "../runtime.js";
import * as Data$dArray from "../Data.Array/index.js";
import * as Data$dMaybe from "../Data.Maybe/index.js";
import * as Data$dMonoid from "../Data.Monoid/index.js";
import * as Data$dRecord$dExtra2 from "../Data.Record.Extra2/index.js";
import * as Data$dSemigroup from "../Data.Semigroup/index.js";
import * as Data$dTuple from "../Data.Tuple/index.js";
import * as Foreign$dObject from "../Foreign.Object/index.js";
import * as Record$dExtra from "../Record.Extra/index.js";
import * as Restaumatic$dAddress from "../Restaumatic.Address/index.js";
import * as Restaumatic$dI18n from "../Restaumatic.I18n/index.js";
import * as Restaumatic$dI18n$dTranslationKeys from "../Restaumatic.I18n.TranslationKeys/index.js";
import * as Restaumatic$dOldForm from "../Restaumatic.OldForm/index.js";
import * as Restaumatic$dPrelude$dSpecular from "../Restaumatic.Prelude.Specular/index.js";
import * as Restaumatic$dSite$dTranslations$dKeys from "../Restaumatic.Site.Translations.Keys/index.js";
import * as Specular$dDom$dBuilder from "../Specular.Dom.Builder/index.js";
import * as Specular$dDom$dElement from "../Specular.Dom.Element/index.js";
import * as Specular$dDom$dWidgets$dSelect from "../Specular.Dom.Widgets.Select/index.js";
import * as Specular$dExtra$dSwitch from "../Specular.Extra.Switch/index.js";
import * as Specular$dFRP$dBase from "../Specular.FRP.Base/index.js";
import * as Specular$dFRP$dWeakDynamic from "../Specular.FRP.WeakDynamic/index.js";
import * as Specular$dInternal$dIncremental from "../Specular.Internal.Incremental/index.js";
import * as Specular$dInternal$dIncremental$dNode from "../Specular.Internal.Incremental.Node/index.js";
import * as Specular$dInternal$dRIO from "../Specular.Internal.RIO/index.js";
import * as Type$dEquality from "../Type.Equality/index.js";
import * as Type$dProxy from "../Type.Proxy/index.js";
import * as Utils$dDynamicFixFRP from "../Utils.DynamicFixFRP/index.js";
const itemWrapper = name => Specular$dDom$dElement.el("div")([Specular$dDom$dElement.class_("m-delivery-address__item m-delivery-address__item--" + name)]);
const houseOrBlockSelect = initial => itemWrapper("house_or_block")(Restaumatic$dOldForm.group((() => {
  const n = Specular$dInternal$dIncremental.constant(Restaumatic$dOldForm.NotChanged);
  Specular$dInternal$dIncremental$dNode.annotate(n, "pure");
  return n;
})())(Specular$dInternal$dRIO.bindImpl(Specular$dDom$dElement.el("label")([
  Specular$dDom$dElement.class_("control-label m-form__label m-form__label--required"),
  Specular$dDom$dElement.attr("for")("house_or_block")
])(Specular$dDom$dElement.text(Restaumatic$dI18n._translate(
  Restaumatic$dI18n$dTranslationKeys.unTranslationKey(Restaumatic$dSite$dTranslations$dKeys.t.formtastic.labels.delivery_address.house_or_block),
  {}
))))(() => {
  const options = [Restaumatic$dAddress.House, Restaumatic$dAddress.Block];
  return Specular$dDom$dElement.el("span")([Specular$dDom$dElement.class_("m-select")])(Specular$dDom$dWidgets$dSelect.selectInput((() => {
    const $0 = Specular$dDom$dBuilder.monoidBuilder(Data$dMonoid.monoidUnit);
    return {
      MonadDomBuilder0: () => Specular$dDom$dBuilder.monadDomBuilderBuilder,
      MonadFRP1: () => ({MonadEffect0: () => Specular$dInternal$dRIO.monadEffectRIO, MonadCleanup1: () => Specular$dDom$dBuilder.monadCleanupBuilder}),
      MonadReplace2: () => Specular$dDom$dBuilder.monadReplaceBuilder,
      Monoid3: () => $0
    };
  })())({
    options,
    initialValueIndex: (() => {
      const $0 = Data$dArray.findIndex(y => {
        if (initial.tag === "House") {
          if (y.tag === "House") { return true; }
          if (y.tag === "Block") { return false; }
          $runtime.fail();
        }
        if (initial.tag === "Block") {
          if (y.tag === "House") { return false; }
          if (y.tag === "Block") { return true; }
          $runtime.fail();
        }
        if (y.tag === "House") { $runtime.fail(); }
        if (y.tag === "Block") { $runtime.fail(); }
        $runtime.fail();
      })(options);
      if ($0.tag === "Nothing") { return 0; }
      if ($0.tag === "Just") { return $0._1; }
      $runtime.fail();
    })(),
    display: Restaumatic$dAddress.displayHouseOrBlock,
    attributes: Specular$dFRP$dWeakDynamic.applicativeWeakDynamic.pure(Foreign$dObject.unionWith(Data$dSemigroup.concatString)((() => {
      const $0 = {};
      $0.id = "house_or_block";
      return $0;
    })())(Foreign$dObject.unionWith(Data$dSemigroup.concatString)((() => {
      const $0 = {};
      $0.class = "form-control m-select__select";
      return $0;
    })())((() => {
      const $0 = {};
      $0.name = "order_deliver_at";
      return $0;
    })())))
  }));
})));
const formField = v => {
  const $0 = v.attrs;
  const $1 = v.initialValue;
  const $2 = v.label;
  const $3 = v.name;
  const $4 = v.overwrite;
  const $5 = v.required;
  return Utils$dDynamicFixFRP.dynamicFixFRPRecord({reflectSymbol: () => "validationState"})()()()()(Utils$dDynamicFixFRP.dynamicFixFRPDynamic)(Utils$dDynamicFixFRP.dynamicFixFRPRecordNil(Type$dEquality.refl)).dynamicFixRecord({
    MonadEffect0: () => Specular$dInternal$dRIO.monadEffectRIO,
    MonadCleanup1: () => Specular$dDom$dBuilder.monadCleanupBuilder
  })(Type$dProxy.Proxy)({validationState: Restaumatic$dOldForm.NotChanged})(a => Specular$dInternal$dRIO.bindImpl(Specular$dInternal$dRIO.mapImpl(v1 => v1.value)((() => {
    const $6 = itemWrapper($3)(Restaumatic$dOldForm.textField$p(Restaumatic$dOldForm.renderErrorString)({
      name: $3,
      label: $2,
      attrs: $0,
      initialValue: $1,
      required: $5,
      validationState: a.validationState,
      autoFormat: Data$dMaybe.Nothing
    })($4));
    return env => $6({parent: env.parent, cleanup: env.cleanup, userEnv: undefined});
  })()))(value => Specular$dInternal$dRIO.bindImpl(Specular$dInternal$dRIO.mapImpl(v1 => v1.forceShowValidationErrors)(Specular$dDom$dBuilder.monadAskBuilder.ask))(forceShowErrors => Specular$dInternal$dRIO.bindImpl(Specular$dFRP$dBase.foldDynMaybe({
    MonadEffect0: () => Specular$dInternal$dRIO.monadEffectRIO,
    MonadCleanup1: () => Specular$dDom$dBuilder.monadCleanupBuilder
  })($$new => old => {
    if ($$new === old) { return Data$dMaybe.Nothing; }
    return Data$dMaybe.$Maybe("Just", $$new);
  })(false)(Specular$dFRP$dBase.leftmost([Specular$dFRP$dBase.functorEvent.map(v$1 => true)(value), Specular$dFRP$dBase.filterEvent(x => x)(forceShowErrors)])))(hasChanged => {
    const validate = v1 => {
      if (v1 === "") {
        if ($5) {
          return Restaumatic$dOldForm.$ValidationState(
            "Error",
            Restaumatic$dI18n._translate(Restaumatic$dI18n$dTranslationKeys.unTranslationKey(Restaumatic$dSite$dTranslations$dKeys.t.errors.messages.blank), {})
          );
        }
        return Restaumatic$dOldForm.Success;
      }
      return Restaumatic$dOldForm.Success;
    };
    return Specular$dInternal$dRIO.pureImpl(Data$dTuple.$Tuple(
      {
        validationState: Specular$dFRP$dBase.bindDynamic.bind(hasChanged)(changed => {
          if (changed) { return Specular$dFRP$dBase.functorDynamic.map($6 => validate($6))(value); }
          return (() => {
            const n = Specular$dInternal$dIncremental.constant(Restaumatic$dOldForm.NotChanged);
            Specular$dInternal$dIncremental$dNode.annotate(n, "pure");
            return n;
          })();
        })
      },
      {
        valid: Specular$dFRP$dBase.functorDynamic.map(v1 => {
          if (validate(v1).tag === "Success") { return Data$dMaybe.$Maybe("Just", v1); }
          return Data$dMaybe.Nothing;
        })(value),
        raw: value
      }
    ));
  }))));
};
const emptyRawDeliveryAddress = {street: "", streetNumber: "", city: "", postCode: "", extra: Restaumatic$dAddress.emptyAddressExtra};
const defaultAptInfoWidget = v => Specular$dInternal$dRIO.bindImpl(formField({
  name: "apt-number",
  label: Restaumatic$dI18n._translate(
    Restaumatic$dI18n$dTranslationKeys.unTranslationKey(Restaumatic$dSite$dTranslations$dKeys.t.activerecord.attributes.delivery_address.apt_number),
    {}
  ),
  attrs: (() => {
    const $0 = {};
    $0["data-testid"] = "deliveryAddress/aptNumber";
    return $0;
  })(),
  initialValue: v.aptNumber,
  required: false,
  overwrite: Specular$dFRP$dBase.never
}))(aptNumber => Specular$dInternal$dRIO.bindImpl(formField({
  name: "floor",
  label: Restaumatic$dI18n._translate(
    Restaumatic$dI18n$dTranslationKeys.unTranslationKey(Restaumatic$dSite$dTranslations$dKeys.t.activerecord.attributes.delivery_address.floor),
    {}
  ),
  attrs: (() => {
    const $0 = {};
    $0["data-testid"] = "deliveryAddress/floor";
    return $0;
  })(),
  initialValue: v.floor,
  required: false,
  overwrite: Specular$dFRP$dBase.never
}))(floor => Specular$dInternal$dRIO.pureImpl(Specular$dFRP$dBase.functorDynamic.map(Restaumatic$dAddress.AddressExtra)(Record$dExtra.sequenceRecord()(Record$dExtra.sequenceRecordCons({
  reflectSymbol: () => "additionalInfo"
})()(Specular$dFRP$dBase.applyDynamic)(Record$dExtra.sequenceRecordCons({reflectSymbol: () => "aptNumber"})()(Specular$dFRP$dBase.applyDynamic)(Record$dExtra.sequenceRecordCons({
  reflectSymbol: () => "block"
})()(Specular$dFRP$dBase.applyDynamic)(Record$dExtra.sequenceRecordCons({reflectSymbol: () => "floor"})()(Specular$dFRP$dBase.applyDynamic)(Record$dExtra.sequenceRecordCons({
  reflectSymbol: () => "houseOrBlock"
})()(Specular$dFRP$dBase.applyDynamic)(Record$dExtra.sequenceRecordCons({reflectSymbol: () => "interphone"})()(Specular$dFRP$dBase.applyDynamic)(Record$dExtra.sequenceRecordCons({
  reflectSymbol: () => "sector"
})()(Specular$dFRP$dBase.applyDynamic)(Record$dExtra.sequenceRecordSingle({reflectSymbol: () => "staircase"})()(Specular$dFRP$dBase.functorDynamic)()())()())()())()())()())()())()())()())({
  additionalInfo: (() => {
    const n = Specular$dInternal$dIncremental.constant("");
    Specular$dInternal$dIncremental$dNode.annotate(n, "pure");
    return n;
  })(),
  block: (() => {
    const n = Specular$dInternal$dIncremental.constant("");
    Specular$dInternal$dIncremental$dNode.annotate(n, "pure");
    return n;
  })(),
  houseOrBlock: (() => {
    const n = Specular$dInternal$dIncremental.constant(Restaumatic$dAddress.House);
    Specular$dInternal$dIncremental$dNode.annotate(n, "pure");
    return n;
  })(),
  interphone: (() => {
    const n = Specular$dInternal$dIncremental.constant("");
    Specular$dInternal$dIncremental$dNode.annotate(n, "pure");
    return n;
  })(),
  sector: (() => {
    const n = Specular$dInternal$dIncremental.constant("");
    Specular$dInternal$dIncremental$dNode.annotate(n, "pure");
    return n;
  })(),
  staircase: (() => {
    const n = Specular$dInternal$dIncremental.constant("");
    Specular$dInternal$dIncremental$dNode.annotate(n, "pure");
    return n;
  })(),
  aptNumber: aptNumber.raw,
  floor: floor.raw
})))));
const br = /* #__PURE__ */ Specular$dDom$dElement.el("div")([/* #__PURE__ */ Specular$dDom$dElement.class_("m-delivery-address__br")])(Restaumatic$dPrelude$dSpecular.wempty);
const romanianAptInfoWidget = v => Specular$dInternal$dRIO.bindImpl(formField({
  name: "sector",
  label: Restaumatic$dI18n._translate(Restaumatic$dI18n$dTranslationKeys.unTranslationKey(Restaumatic$dSite$dTranslations$dKeys.t.formtastic.labels.delivery_address.sector), {}),
  attrs: (() => {
    const $0 = {};
    $0["data-testid"] = "deliveryAddress/sector";
    return $0;
  })(),
  initialValue: v.sector,
  required: false,
  overwrite: Specular$dFRP$dBase.never
}))(sector => Specular$dInternal$dRIO.bindImpl(br)(() => Specular$dInternal$dRIO.bindImpl(env => houseOrBlockSelect(v.houseOrBlock)({
  parent: env.parent,
  cleanup: env.cleanup,
  userEnv: undefined
}))(houseOrBlock => Specular$dInternal$dRIO.bindImpl(br)(() => Specular$dInternal$dRIO.bindImpl(Specular$dExtra$dSwitch.dynamicSwitch(Specular$dExtra$dSwitch.switchDynamic)(Specular$dDom$dBuilder.monadReplaceBuilder)({
  MonadEffect0: () => Specular$dInternal$dRIO.monadEffectRIO,
  MonadCleanup1: () => Specular$dDom$dBuilder.monadCleanupBuilder
})(Specular$dFRP$dBase.functorDynamic.map(v1 => {
  if (v1.tag === "Block") {
    return Specular$dInternal$dRIO.bindImpl(formField({
      name: "block",
      label: Restaumatic$dI18n._translate(Restaumatic$dI18n$dTranslationKeys.unTranslationKey(Restaumatic$dSite$dTranslations$dKeys.t.formtastic.labels.delivery_address.block), {}),
      attrs: (() => {
        const $0 = {};
        $0["data-testid"] = "deliveryAddress/block";
        return $0;
      })(),
      initialValue: v.block,
      required: true,
      overwrite: Specular$dFRP$dBase.never
    }))(block => Specular$dInternal$dRIO.bindImpl(formField({
      name: "staircase",
      label: Restaumatic$dI18n._translate(
        Restaumatic$dI18n$dTranslationKeys.unTranslationKey(Restaumatic$dSite$dTranslations$dKeys.t.formtastic.labels.delivery_address.staircase),
        {}
      ),
      attrs: (() => {
        const $0 = {};
        $0["data-testid"] = "deliveryAddress/staircase";
        return $0;
      })(),
      initialValue: v.staircase,
      required: true,
      overwrite: Specular$dFRP$dBase.never
    }))(staircase => Specular$dInternal$dRIO.bindImpl(br)(() => Specular$dInternal$dRIO.bindImpl(formField({
      name: "floor",
      label: Restaumatic$dI18n._translate(Restaumatic$dI18n$dTranslationKeys.unTranslationKey(Restaumatic$dSite$dTranslations$dKeys.t.formtastic.labels.delivery_address.floor), {}),
      attrs: (() => {
        const $0 = {};
        $0["data-testid"] = "deliveryAddress/floor";
        return $0;
      })(),
      initialValue: v.floor,
      required: true,
      overwrite: Specular$dFRP$dBase.never
    }))(floor => Specular$dInternal$dRIO.bindImpl(formField({
      name: "apt-number",
      label: Restaumatic$dI18n._translate(
        Restaumatic$dI18n$dTranslationKeys.unTranslationKey(Restaumatic$dSite$dTranslations$dKeys.t.formtastic.labels.delivery_address.apt_number),
        {}
      ),
      attrs: (() => {
        const $0 = {};
        $0["data-testid"] = "deliveryAddress/aptNumber";
        return $0;
      })(),
      initialValue: v.aptNumber,
      required: true,
      overwrite: Specular$dFRP$dBase.never
    }))(aptNumber => Specular$dInternal$dRIO.bindImpl(br)(() => Specular$dInternal$dRIO.bindImpl(formField({
      name: "interphone",
      label: Restaumatic$dI18n._translate(
        Restaumatic$dI18n$dTranslationKeys.unTranslationKey(Restaumatic$dSite$dTranslations$dKeys.t.formtastic.labels.delivery_address.interphone),
        {}
      ),
      attrs: (() => {
        const $0 = {};
        $0["data-testid"] = "deliveryAddress/interphone";
        return $0;
      })(),
      initialValue: v.interphone,
      required: false,
      overwrite: Specular$dFRP$dBase.never
    }))(interphone => Specular$dInternal$dRIO.bindImpl(br)(() => Specular$dInternal$dRIO.pureImpl(Specular$dFRP$dBase.functorDynamic.map(Restaumatic$dAddress.AddressExtra)(Record$dExtra.sequenceRecord()(Record$dExtra.sequenceRecordCons({
      reflectSymbol: () => "additionalInfo"
    })()(Specular$dFRP$dBase.applyDynamic)(Record$dExtra.sequenceRecordCons({reflectSymbol: () => "aptNumber"})()(Specular$dFRP$dBase.applyDynamic)(Record$dExtra.sequenceRecordCons({
      reflectSymbol: () => "block"
    })()(Specular$dFRP$dBase.applyDynamic)(Record$dExtra.sequenceRecordCons({reflectSymbol: () => "floor"})()(Specular$dFRP$dBase.applyDynamic)(Record$dExtra.sequenceRecordCons({
      reflectSymbol: () => "houseOrBlock"
    })()(Specular$dFRP$dBase.applyDynamic)(Record$dExtra.sequenceRecordCons({reflectSymbol: () => "interphone"})()(Specular$dFRP$dBase.applyDynamic)(Record$dExtra.sequenceRecordCons({
      reflectSymbol: () => "sector"
    })()(Specular$dFRP$dBase.applyDynamic)(Record$dExtra.sequenceRecordSingle({reflectSymbol: () => "staircase"})()(Specular$dFRP$dBase.functorDynamic)()())()())()())()())()())()())()())()())({
      additionalInfo: (() => {
        const n = Specular$dInternal$dIncremental.constant("");
        Specular$dInternal$dIncremental$dNode.annotate(n, "pure");
        return n;
      })(),
      block: block.raw,
      houseOrBlock: (() => {
        const n = Specular$dInternal$dIncremental.constant(Restaumatic$dAddress.Block);
        Specular$dInternal$dIncremental$dNode.annotate(n, "pure");
        return n;
      })(),
      interphone: interphone.raw,
      sector: (() => {
        const n = Specular$dInternal$dIncremental.constant("");
        Specular$dInternal$dIncremental$dNode.annotate(n, "pure");
        return n;
      })(),
      staircase: staircase.raw,
      aptNumber: aptNumber.raw,
      floor: floor.raw
    })))))))))));
  }
  if (v1.tag === "House") {
    return Specular$dInternal$dRIO.pureImpl((() => {
      const n = Specular$dInternal$dIncremental.constant({
        houseOrBlock: Restaumatic$dAddress.House,
        additionalInfo: "",
        aptNumber: "",
        block: "",
        floor: "",
        interphone: "",
        sector: "",
        staircase: ""
      });
      Specular$dInternal$dIncremental$dNode.annotate(n, "pure");
      return n;
    })());
  }
  $runtime.fail();
})(houseOrBlock)))(extra => Specular$dInternal$dRIO.bindImpl(formField({
  name: "additionalInfo",
  label: Restaumatic$dI18n._translate(
    Restaumatic$dI18n$dTranslationKeys.unTranslationKey(Restaumatic$dSite$dTranslations$dKeys.t.formtastic.labels.delivery_address.additional_info),
    {}
  ),
  attrs: (() => {
    const $0 = {};
    $0["data-testid"] = "deliveryAddress/additionalInfo";
    return $0;
  })(),
  initialValue: v.additionalInfo,
  required: false,
  overwrite: Specular$dFRP$dBase.never
}))(additionalInfo => Specular$dInternal$dRIO.pureImpl(Specular$dFRP$dBase.bindDynamic.bind(sector.raw)(sector$p => Specular$dFRP$dBase.bindDynamic.bind(additionalInfo.raw)(additionalInfo$p => Specular$dFRP$dBase.bindDynamic.bind(extra)(extra$p => {
  const n = Specular$dInternal$dIncremental.constant({
    additionalInfo: additionalInfo$p,
    sector: sector$p,
    aptNumber: extra$p.aptNumber,
    block: extra$p.block,
    floor: extra$p.floor,
    houseOrBlock: extra$p.houseOrBlock,
    interphone: extra$p.interphone,
    staircase: extra$p.staircase
  });
  Specular$dInternal$dIncremental$dNode.annotate(n, "pure");
  return n;
}))))))))));
const addressWidget = config => initial => {
  const emptyField = Specular$dInternal$dRIO.pureImpl({
    valid: (() => {
      const n = Specular$dInternal$dIncremental.constant(Data$dMaybe.$Maybe("Just", ""));
      Specular$dInternal$dIncremental$dNode.annotate(n, "pure");
      return n;
    })(),
    raw: (() => {
      const n = Specular$dInternal$dIncremental.constant("");
      Specular$dInternal$dIncremental$dNode.annotate(n, "pure");
      return n;
    })()
  });
  return Specular$dInternal$dRIO.bindImpl(formField({
    name: "street",
    label: Restaumatic$dI18n._translate(
      Restaumatic$dI18n$dTranslationKeys.unTranslationKey(Restaumatic$dSite$dTranslations$dKeys.t.activerecord.attributes.delivery_address.street),
      {}
    ),
    attrs: Foreign$dObject.unionWith(Data$dSemigroup.concatString)((() => {
      const $0 = {};
      $0.autocomplete = "shipping address-line1";
      return $0;
    })())((() => {
      const $0 = {};
      $0["data-testid"] = "deliveryAddress/street";
      return $0;
    })()),
    initialValue: initial.street,
    required: true,
    overwrite: Specular$dFRP$dBase.functorEvent.map(x => x.street)(config.geocodingAddressE)
  }))(street => Specular$dInternal$dRIO.bindImpl(formField({
    name: "street-number",
    label: Restaumatic$dI18n._translate(
      Restaumatic$dI18n$dTranslationKeys.unTranslationKey(Restaumatic$dSite$dTranslations$dKeys.t.activerecord.attributes.delivery_address.street_number),
      {}
    ),
    attrs: Foreign$dObject.unionWith(Data$dSemigroup.concatString)((() => {
      const $0 = {};
      $0.autocomplete = "shipping address-line2";
      return $0;
    })())((() => {
      const $0 = {};
      $0["data-testid"] = "deliveryAddress/streetNumber";
      return $0;
    })()),
    initialValue: initial.streetNumber,
    required: true,
    overwrite: Specular$dFRP$dBase.functorEvent.map(x => x.streetNumber)(config.geocodingAddressE)
  }))(streetNumber => Specular$dInternal$dRIO.bindImpl(br)(() => Specular$dInternal$dRIO.bindImpl(formField({
    name: "city",
    label: Restaumatic$dI18n._translate(
      Restaumatic$dI18n$dTranslationKeys.unTranslationKey(Restaumatic$dSite$dTranslations$dKeys.t.activerecord.attributes.delivery_address.city),
      {}
    ),
    attrs: Foreign$dObject.unionWith(Data$dSemigroup.concatString)((() => {
      const $0 = {};
      $0.autocomplete = "shipping address-level2";
      return $0;
    })())((() => {
      const $0 = {};
      $0["data-testid"] = "deliveryAddress/city";
      return $0;
    })()),
    initialValue: initial.city,
    required: true,
    overwrite: Specular$dFRP$dBase.functorEvent.map(x => x.city)(config.geocodingAddressE)
  }))(city => Specular$dInternal$dRIO.bindImpl(Restaumatic$dAddress.isPostCodeRequired(config.accountId)(config.country)
    ? formField({
        name: "post-code",
        label: Restaumatic$dI18n._translate(
          Restaumatic$dI18n$dTranslationKeys.unTranslationKey(Restaumatic$dSite$dTranslations$dKeys.t.activerecord.attributes.delivery_address.post_code),
          {}
        ),
        attrs: Foreign$dObject.unionWith(Data$dSemigroup.concatString)((() => {
          const $0 = {};
          $0.autocomplete = "shipping postal-code";
          return $0;
        })())((() => {
          const $0 = {};
          $0["data-testid"] = "deliveryAddress/postCode";
          return $0;
        })()),
        initialValue: initial.postCode,
        required: true,
        overwrite: Specular$dFRP$dBase.never
      })
    : emptyField)(postCode => Specular$dInternal$dRIO.bindImpl(br)(() => Specular$dInternal$dRIO.bindImpl((() => {
    if (config.withAptInfo) {
      if (config.country.tag === "RO") { return romanianAptInfoWidget(initial.extra); }
      return defaultAptInfoWidget(initial.extra);
    }
    return Specular$dInternal$dRIO.pureImpl((() => {
      const n = Specular$dInternal$dIncremental.constant(Restaumatic$dAddress.emptyAddressExtra);
      Specular$dInternal$dIncremental$dNode.annotate(n, "pure");
      return n;
    })());
  })())(extra => Specular$dInternal$dRIO.pureImpl({
    validAddress: (() => {
      const $0 = config.country;
      return Specular$dFRP$dBase.functorDynamic.map(v1 => {
        if (v1.tag === "Just") {
          return Data$dMaybe.$Maybe(
            "Just",
            {
              formattedAddress: $0.tag === "RO" ? Data$dMaybe.$Maybe("Just", Restaumatic$dAddress.formatRomanianAddress(v1._1)) : Data$dMaybe.Nothing,
              aptNumber: v1._1.aptNumber,
              city: v1._1.city,
              country: v1._1.country,
              extra: v1._1.extra,
              floor: v1._1.floor,
              postCode: v1._1.postCode,
              street: v1._1.street,
              streetNumber: v1._1.streetNumber
            }
          );
        }
        return Data$dMaybe.Nothing;
      })(Specular$dFRP$dBase.functorDynamic.map(Data$dMaybe.functorMaybe.map(Restaumatic$dAddress.DeliveryAddress))(Data$dRecord$dExtra2.rsequence2(Specular$dFRP$dBase.functorDynamic)()(Data$dMaybe.applicativeMaybe)(Record$dExtra.sequenceRecordCons({
        reflectSymbol: () => "aptNumber"
      })()(Data$dMaybe.applyMaybe)(Record$dExtra.sequenceRecordCons({reflectSymbol: () => "city"})()(Data$dMaybe.applyMaybe)(Record$dExtra.sequenceRecordCons({
        reflectSymbol: () => "country"
      })()(Data$dMaybe.applyMaybe)(Record$dExtra.sequenceRecordCons({reflectSymbol: () => "extra"})()(Data$dMaybe.applyMaybe)(Record$dExtra.sequenceRecordCons({
        reflectSymbol: () => "floor"
      })()(Data$dMaybe.applyMaybe)(Record$dExtra.sequenceRecordCons({reflectSymbol: () => "formattedAddress"})()(Data$dMaybe.applyMaybe)(Record$dExtra.sequenceRecordCons({
        reflectSymbol: () => "postCode"
      })()(Data$dMaybe.applyMaybe)(Record$dExtra.sequenceRecordCons({reflectSymbol: () => "street"})()(Data$dMaybe.applyMaybe)(Record$dExtra.sequenceRecordSingle({
        reflectSymbol: () => "streetNumber"
      })()(Data$dMaybe.functorMaybe)()())()())()())()())()())()())()())()())()())()(Specular$dFRP$dBase.applicativeDynamic)(Record$dExtra.sequenceRecordCons({
        reflectSymbol: () => "aptNumber"
      })()(Specular$dFRP$dBase.applyDynamic)(Record$dExtra.sequenceRecordCons({reflectSymbol: () => "city"})()(Specular$dFRP$dBase.applyDynamic)(Record$dExtra.sequenceRecordCons({
        reflectSymbol: () => "country"
      })()(Specular$dFRP$dBase.applyDynamic)(Record$dExtra.sequenceRecordCons({reflectSymbol: () => "extra"})()(Specular$dFRP$dBase.applyDynamic)(Record$dExtra.sequenceRecordCons({
        reflectSymbol: () => "floor"
      })()(Specular$dFRP$dBase.applyDynamic)(Record$dExtra.sequenceRecordCons({reflectSymbol: () => "formattedAddress"})()(Specular$dFRP$dBase.applyDynamic)(Record$dExtra.sequenceRecordCons({
        reflectSymbol: () => "postCode"
      })()(Specular$dFRP$dBase.applyDynamic)(Record$dExtra.sequenceRecordCons({reflectSymbol: () => "street"})()(Specular$dFRP$dBase.applyDynamic)(Record$dExtra.sequenceRecordSingle({
        reflectSymbol: () => "streetNumber"
      })()(Specular$dFRP$dBase.functorDynamic)()())()())()())()())()())()())()())()())()())({
        street: street.valid,
        streetNumber: streetNumber.valid,
        city: city.valid,
        postCode: postCode.valid,
        aptNumber: Specular$dFRP$dBase.functorDynamic.map(x => Data$dMaybe.$Maybe("Just", x.aptNumber))(extra),
        floor: Specular$dFRP$dBase.functorDynamic.map(x => Data$dMaybe.$Maybe("Just", x.floor))(extra),
        country: (() => {
          const $1 = Data$dMaybe.$Maybe("Just", config.country);
          return (() => {
            const n = Specular$dInternal$dIncremental.constant($1);
            Specular$dInternal$dIncremental$dNode.annotate(n, "pure");
            return n;
          })();
        })(),
        extra: Specular$dFRP$dBase.functorDynamic.map(x => Data$dMaybe.$Maybe("Just", Data$dMaybe.$Maybe("Just", x)))(extra),
        formattedAddress: (() => {
          const n = Specular$dInternal$dIncremental.constant(Data$dMaybe.$Maybe("Just", Data$dMaybe.Nothing));
          Specular$dInternal$dIncremental$dNode.annotate(n, "pure");
          return n;
        })()
      })));
    })(),
    rawAddress: Record$dExtra.sequenceRecord()(Record$dExtra.sequenceRecordCons({reflectSymbol: () => "city"})()(Specular$dFRP$dBase.applyDynamic)(Record$dExtra.sequenceRecordCons({
      reflectSymbol: () => "extra"
    })()(Specular$dFRP$dBase.applyDynamic)(Record$dExtra.sequenceRecordCons({reflectSymbol: () => "postCode"})()(Specular$dFRP$dBase.applyDynamic)(Record$dExtra.sequenceRecordCons({
      reflectSymbol: () => "street"
    })()(Specular$dFRP$dBase.applyDynamic)(Record$dExtra.sequenceRecordSingle({reflectSymbol: () => "streetNumber"})()(Specular$dFRP$dBase.functorDynamic)()())()())()())()())()())({
      street: street.raw,
      streetNumber: streetNumber.raw,
      city: city.raw,
      postCode: postCode.raw,
      extra
    })
  }))))))));
};
export {addressWidget, br, defaultAptInfoWidget, emptyRawDeliveryAddress, formField, houseOrBlockSelect, itemWrapper, romanianAptInfoWidget};
